import { render, staticRenderFns } from "./UserSecurityLockHistory.vue?vue&type=template&id=a4a851d0&scoped=true&"
import script from "./UserSecurityLockHistory.vue?vue&type=script&lang=js&"
export * from "./UserSecurityLockHistory.vue?vue&type=script&lang=js&"
import style0 from "./UserSecurityLockHistory.vue?vue&type=style&index=0&id=a4a851d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a851d0",
  null
  
)

export default component.exports